import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  LOGIN_FAILED,
  LOGIN_USER_RESET,
  RESET_LOGIN_RESPONSE_MSG,
  SET_CONST_DETAILS,
  FETCH_CONST_DETAILS,
  LOGOUT_USER_FAILED,
  SESSION_TIMEOUT,
} from "./actionTypes"

const initialState = {
  loginError: false,
  loginErrorMessage: null,
  message: null,
  loading: false,
  user: null,
  name: 'hello',
  constDetails: {
    billing_setup: false,
    card_setup: false,
    loading: false
  },
  loginErrorType: null,
  logoutLoading: false,
  logoutErrorMessage: null,
  timeout: false
}

const Login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        user: action.payload.user,
        email: action.payload.user,
        twoFactor: action.payload.twoFactor,
        cmp_phone_code: action.payload.cmp_phone_code,
        cmp_phone: action.payload.cmp_phone,
        dailcode: action.payload.dailcode,
        loginError: false,
        constDetails: {
          ...state.constDetails,
          loading: true
        },
        ...action.payload

      }
      break
    case LOGIN_FAILED:
      state = {
        ...state,
        user: null,
        loading: false,
        loginError: true,
        ...action.payload
      }
      break
    case LOGIN_USER_RESET:
      state = {
        loginError: false,
        loginErrorMessage: null,
        message: null,
        loading: false,
        user: null,
        constDetails: {
          billing_setup: false,
          card_setup: false,
          loading: false
        },
        loginErrorType: null
      }
      break
    case LOGOUT_USER:
      state = { ...state, logoutLoading: true }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state, logoutLoading: false, timeout: action.payload?.timeout || false }
      break
    case LOGOUT_USER_FAILED:
      state = { ...state, logoutLoading: false, logoutErrorMessage: action?.payload?.responseMessage }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case RESET_LOGIN_RESPONSE_MSG:
      state = {
        ...state,
        user: null,
        loading: false,
        loginError: false,
        loginErrorMessage: null,
        // loginErrorType: null
      }
      break
    case FETCH_CONST_DETAILS:
      state = {
        ...state,
        constDetails: {
          ...state.constDetails,
          loading: true,
        }
      }
      break
    case SET_CONST_DETAILS:
      state = {
        ...state,
        constDetails: {
          ...state.constDetails,
          ...action.payload
        }
      }
      break
    case SESSION_TIMEOUT:
      state = {
        ...state,
        timeout: false
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default Login
